import { getBasePath } from "../../utils/encodeUrl";
// `${getBasePath()}/login`
// `${getBasePath()}/noAuth`
// `${getBasePath()}/notFound`
export const microFrontend = (to, from, next) => {
    var _a, _b, _c;
    if (to.path === `${getBasePath()}/login` && ((_a = window.LcapMicro) === null || _a === void 0 ? void 0 : _a.loginFn)) {
        window.LcapMicro.loginFn();
        return;
    }
    if (to.path === `${getBasePath()}/noAuth` && ((_b = window.LcapMicro) === null || _b === void 0 ? void 0 : _b.noAuthFn)) {
        window.LcapMicro.noAuthFn();
        return;
    }
    if (to.path === `${getBasePath()}/notFound` && ((_c = window.LcapMicro) === null || _c === void 0 ? void 0 : _c.notFoundFn)) {
        window.LcapMicro.notFoundFn();
        return;
    }
    next();
};
